import axios from "axios";

const getAssignFailJob = (uuid) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/serialnumber/api/v1/assign/${uuid}/fail-job`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getAssignFailJob;
